import { MAP } from 'cadenza/map-dashboard/event-types';
import { LayerProperty } from 'cadenza/map/layer-property';
import {
  createFeatureSelectionData,
  hasAttributeTable,
  resetSelection
} from 'cadenza/map/layer-utils';
import { deselectFeatures } from 'cadenza/api-client/maps-api';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class FeatureDeselect extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('mapConfig.deselectFeatures')
    }, options));
    this.#map = options.map;
  }

  execute () {
    const layerId = this._layer.get(LayerProperty.ID);
    return deselectFeatures([ layerId ])
      .then(() => {
        if (hasAttributeTable(this.layer)) {
          const detail = createFeatureSelectionData([ layerId ], []);
          this.#map.getTargetElement().dispatchEvent(new CustomEvent(MAP.SELECTOR_LAYER_SELECTION_CHANGED, { detail }));
        }
        resetSelection(this._layer);
      });
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && this._layer.get(LayerProperty.HAS_FEATURES) && this._layer.get(LayerProperty.SELECTED_FEATURE_IDS).length > 0;
  }

  requiresObjectSelection () {
    return true;
  }

}
